export const helpers = {
  //for deep copy
  deepCopy: (obj) => {
    return JSON.parse(JSON.stringify(obj));
  },
};
